import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
ActiveStorage.start()

const flatpickr = require("flatpickr");
window.Choices = require("choices.js");
const Notifications = require("simple-notifications-solution");

import './legacy.scss';
import './legacy_client.scss';

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

const notifications = new Notifications();
notifications.init();

import "controllers"

require("trix")
require("@rails/actiontext")
